/* Nosenose theme — global interactions */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money formatting (mirrors Shopify shop currency) ---------- */
  var MONEY_FORMAT = (window.theme && window.theme.moneyFormat) || 'NT${{amount_no_decimals}}';
  function formatMoney(cents) {
    var value = '';
    var n = Number(cents || 0);
    function commas(num) { return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'); }
    var amountNoDecimals = commas(Math.round(n / 100));
    var amount2 = commas((n / 100).toFixed(2));
    value = MONEY_FORMAT
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount2);
    return value;
  }

  /* ---------- Open / close helpers ---------- */
  function openEl(el, overlay) { if (el) el.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
  function closeEl(el, overlay) { if (el) el.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); document.documentElement.style.overflow = ''; }

  document.addEventListener('DOMContentLoaded', function () {

    /* ===== Header search toggle ===== */
    var searchToggle = $('[data-search-toggle]');
    var searchBar = $('[data-search-bar]');
    if (searchToggle && searchBar) {
      searchToggle.addEventListener('click', function () {
        var hidden = searchBar.hasAttribute('hidden');
        if (hidden) { searchBar.removeAttribute('hidden'); var i = $('input', searchBar); if (i) i.focus(); }
        else { searchBar.setAttribute('hidden', ''); }
      });
      var sClose = $('[data-search-close]', searchBar);
      if (sClose) sClose.addEventListener('click', function () { searchBar.setAttribute('hidden', ''); });
    }

    /* ===== Mobile menu toggle ===== */
    var menuToggle = $('[data-menu-toggle]');
    var mobileMenu = $('[data-mobile-menu]');
    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function () {
        var hidden = mobileMenu.hasAttribute('hidden');
        if (hidden) { mobileMenu.removeAttribute('hidden'); menuToggle.setAttribute('aria-expanded', 'true'); }
        else { mobileMenu.setAttribute('hidden', ''); menuToggle.setAttribute('aria-expanded', 'false'); }
      });
    }

    /* ===== Cart drawer ===== */
    var cartDrawer = $('[data-cart-drawer]');
    var overlay = $('[data-overlay]');
    $$('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); openEl(cartDrawer, overlay); });
    });
    $$('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeEl(cartDrawer, overlay); });
    });

    if (overlay) overlay.addEventListener('click', function () {
      closeEl(cartDrawer, overlay);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeEl(cartDrawer, overlay); }
    });

    /* Quantity stepper on product detail is handled by the product section's
       own controller (variant + qty + live total price), so no generic
       handler is needed here. */

    /* ===== Wishlist (localStorage, client-side only) ===== */
    var WL_KEY = 'nosenose_wishlist';
    function getWishlist() { try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; } }
    function setWishlist(arr) { try { localStorage.setItem(WL_KEY, JSON.stringify(arr)); } catch (e) {} }
    function syncWishlistUI() {
      var wl = getWishlist();
      $$('[data-wishlist]').forEach(function (btn) {
        var id = btn.getAttribute('data-wishlist');
        btn.classList.toggle('is-active', wl.indexOf(id) !== -1);
      });
    }
    $$('[data-wishlist]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var id = btn.getAttribute('data-wishlist');
        var wl = getWishlist();
        var i = wl.indexOf(id);
        if (i === -1) wl.push(id); else wl.splice(i, 1);
        setWishlist(wl); syncWishlistUI();
      });
    });
    syncWishlistUI();

    /* ===== AJAX cart ===== */
    function refreshCart() {
      fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); });
    }

    function renderCart(cart) {
      // count badges
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
      var body = $('[data-cart-body]');
      var foot = $('[data-cart-foot]');
      var titleCount = $('[data-cart-title-count]');
      if (titleCount) titleCount.textContent = cart.item_count;
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML =
          '<div class="cart-empty">' +
          '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
          '<p>' + ((window.theme.labels && window.theme.labels.cartEmpty) || '購物車是空的') + '</p></div>';
        if (foot) foot.innerHTML = '';
        return;
      }

      var html = '';
      cart.items.forEach(function (item) {
        html +=
          '<div class="cart-line" data-line-key="' + item.key + '">' +
            '<img src="' + (item.image ? item.image.replace(/(\.[^.]+)(\?.*)?$/, '_120x150$1') : '') + '" alt="' + item.product_title + '">' +
            '<div class="meta">' +
              '<p class="lname">' + item.product_title + '</p>' +
              '<p class="lprice">' + formatMoney(item.final_price) + '</p>' +
            '</div>' +
            '<div class="stepper">' +
              '<button data-line-dec aria-label="減少數量"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' +
              '<span class="v">' + item.quantity + '</span>' +
              '<button data-line-inc aria-label="增加數量"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' +
            '</div>' +
          '</div>';
      });
      body.innerHTML = html;

      var threshold = (window.theme && window.theme.freeShipThreshold) || 100000; // cents
      var shipTpl = (window.theme.labels && window.theme.labels.freeShip) || '再加 [amount] 即可享免運費';
      var hint = cart.total_price < threshold
        ? '<p class="ship-hint">' + shipTpl.replace('[amount]', formatMoney(threshold - cart.total_price)) + '</p>' : '';
      if (foot) {
        foot.innerHTML =
          '<div class="subtotal-row"><span class="lbl">' + ((window.theme.labels && window.theme.labels.subtotal) || 'SUBTOTAL') + '</span><span class="amt">' + formatMoney(cart.total_price) + '</span></div>' +
          hint +
          '<a href="' + window.Shopify.routes.root + 'checkout" class="btn-solid" style="text-align:center;">' + ((window.theme.labels && window.theme.labels.checkout) || 'CHECKOUT') + '</a>';
      }
      bindLineEvents();
    }

    function bindLineEvents() {
      $$('[data-line-key]').forEach(function (line) {
        var key = line.getAttribute('data-line-key');
        var dec = $('[data-line-dec]', line);
        var inc = $('[data-line-inc]', line);
        var cur = parseInt($('.v', line).textContent, 10);
        if (dec) dec.addEventListener('click', function () { changeLine(key, cur - 1); });
        if (inc) inc.addEventListener('click', function () { changeLine(key, cur + 1); });
      });
    }

    function changeLine(key, qty) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }

    function addToCart(variantId, qty, openDrawer) {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 })
      }).then(function (r) { return r.json(); }).then(function () {
        refreshCart();
        if (openDrawer) openEl(cartDrawer, overlay);
      });
    }

    // Quick-add buttons on product cards
    $$('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var vid = btn.getAttribute('data-quick-add');
        if (!vid) return;
        btn.disabled = true;
        addToCart(vid, 1, true).finally(function () { btn.disabled = false; });
      });
    });

    // Product form add-to-cart (AJAX, prevents full reload)
    var pForm = $('[data-product-form]');
    if (pForm) {
      pForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var vid = $('[name="id"]', pForm).value;
        var qtyEl = $('[data-qty-input]', pForm);
        var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
        var submit = $('[type="submit"]', pForm);
        if (submit) submit.disabled = true;
        addToCart(vid, qty, true).finally(function () { if (submit) submit.disabled = false; });
      });
    }

    /* ===== Layered scroll reveal + parallax ===== */
    (function () {
      if (!document.body.classList.contains('anim-on')) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var reveals = $$('[data-reveal]');
      reveals.forEach(function (el) {
        var d = el.getAttribute('data-reveal-delay');
        if (d) el.style.setProperty('--reveal-d', d);
      });
      if (reduce || !('IntersectionObserver' in window)) {
        reveals.forEach(function (el) { el.classList.add('is-visible'); });
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        reveals.forEach(function (el) { io.observe(el); });
      }

      if (!reduce) {
        var px = $$('[data-parallax]');
        if (px.length) {
          var ticking = false;
          var run = function () {
            if (ticking) return; ticking = true;
            requestAnimationFrame(function () {
              var vh = window.innerHeight;
              px.forEach(function (el) {
                var r = el.getBoundingClientRect();
                var center = r.top + r.height / 2;
                var progress = (center - vh / 2) / vh;
                var shift = Math.max(-1, Math.min(1, progress)) * -26;
                el.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0) scale(1.12)';
              });
              ticking = false;
            });
          };
          window.addEventListener('scroll', run, { passive: true });
          window.addEventListener('resize', run);
          run();
        }
      }
    })();

    // Initial load — sync cart counts/drawer from server
    refreshCart();
  });
})();
